// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.People_people__N4JdE {
  padding-bottom: 140px;
}
.People_people__N4JdE .People_cards__1WiNZ {
  display: flex;
  gap: 90px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
@media (max-width: 920px) {
  .People_people__N4JdE .People_cards__1WiNZ {
    gap: 50px;
  }
}
@media (max-width: 760px) {
  .People_people__N4JdE .People_cards__1WiNZ {
    gap: 80px;
  }
}
.People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P {
  position: relative;
  width: 100%;
  max-width: 310px;
  min-width: 200px;
}
.People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P .People_inst__1mC3N {
  position: absolute;
  z-index: 1;
  bottom: 80px;
  left: -10px;
}
@media (max-width: 760px) {
  .People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P .People_inst__1mC3N {
    bottom: 20px;
  }
}
.People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P .People_box_foto__3ZJ6d .People_foto__ESwpx {
  width: 100%;
}
.People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P .People_btn__6q7ld {
  position: absolute;
  z-index: 1;
  bottom: -10px;
  left: -20px;
}
@media (max-width: 760px) {
  .People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P .People_btn__6q7ld {
    bottom: auto;
    left: auto;
    top: calc(100% + 10px);
    right: -10px;
    font-size: 1.2rem;
    background: transparent !important;
    color: var(--red) !important;
  }
}
@media (max-width: 760px) {
  .People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P {
    max-width: 100%;
    min-width: 100%;
    height: 400px;
  }
  .People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P .People_box_foto__3ZJ6d {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P .People_box_foto__3ZJ6d .People_foto__ESwpx {
    height: 100%;
    object-fit: cover;
    object-position: -14px;
    width: calc(100% + 28px);
  }
}
@media (max-width: 540px) {
  .People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P {
    height: 300px;
  }
}
@media (max-width: 760px) {
  .People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P {
    border: 7px solid var(--red);
  }
  .People_people__N4JdE .People_cards__1WiNZ .People_card__fqQ6P:first-child {
    border: 7px solid #333;
  }
}
.People_people__N4JdE .People_bg_popup__GAogA {
  position: fixed;
  inset: 0;
  background: rgba(217, 217, 217, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  z-index: 105;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px;
  max-height: 100%;
  overflow-y: auto;
}
@media (max-width: 640px) {
  .People_people__N4JdE .People_bg_popup__GAogA {
    padding: 40px 20px;
  }
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R {
  border: 5px solid var(--red);
  background-color: var(--white);
  position: relative;
  margin: 50px 100px;
  padding: 5vh 3rem;
  box-sizing: border-box;
}
@media (max-width: 1420px) {
  .People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R {
    margin: 50px 20px;
  }
}
@media (max-width: 640px) {
  .People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R {
    margin: 0px 0px !important;
    padding: 4vh 1.5rem;
  }
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(26, 24, 47, 0.15);
  border-radius: 5px;
  height: 200px;
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R::-webkit-scrollbar-thumb {
  background: rgba(255, 0, 0, 0.101);
  border-radius: 8px;
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R h2.People_title__LO0Wo {
  max-width: 58%;
  position: relative;
  display: inline-block;
  font-family: "Beer money";
  font-weight: 400;
  margin: 0;
  font-size: 2rem;
}
@media (max-width: 768px) {
  .People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R h2.People_title__LO0Wo {
    max-width: 80%;
  }
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R h2.People_title__LO0Wo .People_text_inst__G7VlV {
  display: inline-flex;
  align-items: center;
  width: 0px;
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R h2.People_title__LO0Wo .People_text_inst__G7VlV * {
  display: inline-flex;
  transform: scale(1) translate(2px, 2px);
  position: static;
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R h2.People_title__LO0Wo strong {
  font-weight: 400;
  color: var(--red);
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_close__tkx1z {
  position: absolute;
  top: 25px;
  right: 25px;
  padding: 6px 6px 3px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--red);
  border-radius: 50%;
  cursor: pointer;
  border: none;
}
@media (max-width: 480px) {
  .People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_close__tkx1z {
    top: 15px;
    right: 15px;
  }
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_close__tkx1z i {
  display: inline-block;
  font-size: 25px;
  color: var(--white);
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_col__kloOk {
  display: flex;
  align-items: flex-start;
  align-items: center;
  gap: 170px;
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_col__kloOk h2 img {
  width: 1.1em;
}
@media (max-width: 1700px) {
  .People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_col__kloOk {
    gap: 100px;
  }
}
@media (max-width: 1500px) {
  .People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_col__kloOk {
    gap: 80px;
  }
}
@media (max-width: 1150px) {
  .People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_col__kloOk {
    gap: 50px;
  }
}
@media (max-width: 920px) {
  .People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_col__kloOk {
    gap: 20px;
    flex-direction: column;
  }
}
.People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_col__kloOk .People_foto_card__wrC6J {
  width: 35%;
  max-width: 400px;
}
@media (max-width: 920px) {
  .People_people__N4JdE .People_bg_popup__GAogA .People_box_popup__1OG8R .People_col__kloOk .People_foto_card__wrC6J {
    margin: 0 auto;
    width: 100%;
    max-width: 350px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/People/People.module.scss"],"names":[],"mappings":"AAAA;EACG,qBAAA;AACH;AACG;EACG,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AACN;AACM;EAPH;IAQM,SAAA;EAEP;AACF;AAAM;EAXH;IAYM,SAAA;EAGP;AACF;AADM;EACG,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAGT;AADS;EACG,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAGZ;AADY;EANH;IAOM,YAAA;EAIb;AACF;AAAY;EACG,WAAA;AAEf;AAES;EACG,kBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;AAAZ;AAEY;EANH;IAOM,YAAA;IACA,UAAA;IACA,sBAAA;IACA,YAAA;IACA,iBAAA;IACA,kCAAA;IACA,4BAAA;EACb;AACF;AAES;EAxCH;IAyCM,eAAA;IACA,eAAA;IACA,aAAA;EACV;EACU;IACG,WAAA;IACA,YAAA;IACA,gBAAA;EACb;EACa;IACG,YAAA;IACA,iBAAA;IACA,sBAAA;IACA,wBAAA;EAChB;AACF;AAIS;EA5DH;IA6DM,aAAA;EADV;AACF;AAKM;EACG;IACG,4BAAA;EAHV;EAMO;IACG,sBAAA;EAJV;AACF;AAQG;EACG,eAAA;EACA,QAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AANN;AAQM;EAbH;IAcM,kBAAA;EALP;AACF;AAOM;EACG,4BAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AALT;AAOS;EARH;IASM,iBAAA;EAJV;AACF;AAMS;EAZH;IAaM,0BAAA;IACA,mBAAA;EAHV;AACF;AAKS;EACG,UAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;AAHZ;AAMS;EACG,kCAAA;EACA,kBAAA;AAJZ;AAOS;EACG,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AALZ;AAOY;EATH;IAUM,cAAA;EAJb;AACF;AAMY;EACG,oBAAA;EACA,mBAAA;EACA,UAAA;AAJf;AAMe;EACG,oBAAA;EACA,uCAAA;EACA,gBAAA;AAJlB;AAmBY;EACG,gBAAA;EACA,iBAAA;AAjBf;AAqBS;EACG,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAnBZ;AAqBY;EAbH;IAcM,SAAA;IACA,WAAA;EAlBb;AACF;AAoBY;EACG,qBAAA;EACA,eAAA;EACA,mBAAA;AAlBf;AAsBS;EACG,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AApBZ;AAuBe;EACG,YAAA;AArBlB;AAyBY;EAZH;IAaM,UAAA;EAtBb;AACF;AAwBY;EAhBH;IAiBM,SAAA;EArBb;AACF;AAuBY;EApBH;IAqBM,SAAA;EApBb;AACF;AAuBY;EAzBH;IA0BM,SAAA;IACA,sBAAA;EApBb;AACF;AAsBY;EACG,UAAA;EACA,gBAAA;AApBf;AAsBe;EAJH;IAKM,cAAA;IACA,WAAA;IACA,gBAAA;EAnBhB;AACF","sourcesContent":[".people {\r\n   padding-bottom: 140px;\r\n\r\n   .cards {\r\n      display: flex;\r\n      gap: 90px;\r\n      flex-wrap: wrap;\r\n      align-items: center;\r\n      justify-content: center;\r\n\r\n      @media (max-width: 920px) {\r\n         gap: 50px;\r\n      }\r\n\r\n      @media (max-width: 760px) {\r\n         gap: 80px;\r\n      }\r\n\r\n      .card {\r\n         position: relative;\r\n         width: 100%;\r\n         max-width: 310px;\r\n         min-width: 200px;\r\n\r\n         .inst {\r\n            position: absolute;\r\n            z-index: 1;\r\n            bottom: 80px;\r\n            left: -10px;\r\n\r\n            @media (max-width: 760px) {\r\n               bottom: 20px;\r\n            }\r\n         }\r\n\r\n         .box_foto {\r\n            .foto {\r\n               width: 100%;\r\n            }\r\n         }\r\n\r\n         .btn {\r\n            position: absolute;\r\n            z-index: 1;\r\n            bottom: -10px;\r\n            left: -20px;\r\n\r\n            @media (max-width: 760px) {\r\n               bottom: auto;\r\n               left: auto;\r\n               top: calc(100% + 10px);\r\n               right: -10px;\r\n               font-size: 1.2rem;\r\n               background: transparent !important;\r\n               color: var(--red) !important;\r\n            }\r\n         }\r\n\r\n         @media (max-width: 760px) {\r\n            max-width: 100%;\r\n            min-width: 100%;\r\n            height: 400px;\r\n\r\n            .box_foto {\r\n               width: 100%;\r\n               height: 100%;\r\n               overflow: hidden;\r\n\r\n               .foto {\r\n                  height: 100%;\r\n                  object-fit: cover;\r\n                  object-position: -14px;\r\n                  width: calc(100% + 28px);\r\n               }\r\n            }\r\n\r\n         }\r\n\r\n         @media (max-width: 540px) {\r\n            height: 300px;\r\n         }\r\n\r\n      }\r\n\r\n      @media (max-width: 760px) {\r\n         .card {\r\n            border: 7px solid var(--red);\r\n         }\r\n\r\n         .card:first-child {\r\n            border: 7px solid #333;\r\n         }\r\n      }\r\n   }\r\n\r\n   .bg_popup {\r\n      position: fixed;\r\n      inset: 0;\r\n      background: rgba(217, 217, 217, 0.1);\r\n      backdrop-filter: blur(10px);\r\n      z-index: 105;\r\n      display: flex;\r\n      align-items: flex-start;\r\n      justify-content: center;\r\n      padding: 40px;\r\n      max-height: 100%;\r\n      overflow-y: auto;\r\n\r\n      @media (max-width: 640px) {\r\n         padding: 40px 20px;\r\n      }\r\n\r\n      .box_popup {\r\n         border: 5px solid var(--red);\r\n         background-color: var(--white);\r\n         position: relative;\r\n         margin: 50px 100px;\r\n         padding: 5vh 3rem;\r\n         box-sizing: border-box;\r\n\r\n         @media (max-width: 1420px) {\r\n            margin: 50px 20px;\r\n         }\r\n\r\n         @media (max-width: 640px) {\r\n            margin: 0px 0px !important;\r\n            padding: 4vh 1.5rem;\r\n         }\r\n\r\n         &::-webkit-scrollbar {\r\n            width: 8px;\r\n            background-color: rgba(26, 24, 47, 0.15);\r\n            border-radius: 5px;\r\n            height: 200px;\r\n         }\r\n\r\n         &::-webkit-scrollbar-thumb {\r\n            background: rgba(255, 0, 0, 0.101);\r\n            border-radius: 8px;\r\n         }\r\n\r\n         h2.title {\r\n            max-width: 58%;\r\n            position: relative;\r\n            display: inline-block;\r\n            font-family: \"Beer money\";\r\n            font-weight: 400;\r\n            margin: 0;\r\n            font-size: 2rem;\r\n\r\n            @media (max-width: 768px) {\r\n               max-width: 80%;\r\n            }\r\n\r\n            .text_inst{\r\n               display: inline-flex;\r\n               align-items: center;\r\n               width: 0px;\r\n\r\n               *{\r\n                  display: inline-flex;\r\n                  transform: scale(1) translate(2px, 2px);\r\n                  position: static;\r\n               }\r\n               // width: 0;\r\n               // height: 100%;\r\n               // display: inline-flex;\r\n               // align-items: flex-end;\r\n               // justify-content: center;\r\n               // padding-left: 15px;\r\n               // bottom: 10px;\r\n               // transform: scale(0.7) translate(20px, 12px);\r\n               // position: absolute;\r\n               // left: 100%;\r\n            }\r\n\r\n\r\n            strong {\r\n               font-weight: 400;\r\n               color: var(--red);\r\n            }\r\n         }\r\n\r\n         .close {\r\n            position: absolute;\r\n            top: 25px;\r\n            right: 25px;\r\n            padding: 6px 6px 3px 6px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            background-color: var(--red);\r\n            border-radius: 50%;\r\n            cursor: pointer;\r\n            border: none;\r\n\r\n            @media (max-width: 480px) {\r\n               top: 15px;\r\n               right: 15px;\r\n            }\r\n\r\n            i {\r\n               display: inline-block;\r\n               font-size: 25px;\r\n               color: var(--white);\r\n            }\r\n         }\r\n\r\n         .col {\r\n            display: flex;\r\n            align-items: flex-start;\r\n            align-items: center;\r\n            gap: 170px;\r\n\r\n            h2{\r\n               img{\r\n                  width: 1.1em;\r\n               }\r\n            }\r\n\r\n            @media (max-width: 1700px) {\r\n               gap: 100px;\r\n            }\r\n\r\n            @media (max-width: 1500px) {\r\n               gap: 80px;\r\n            }\r\n\r\n            @media (max-width: 1150px) {\r\n               gap: 50px;\r\n            }\r\n\r\n\r\n            @media (max-width: 920px) {\r\n               gap: 20px;\r\n               flex-direction: column;\r\n            }\r\n\r\n            .foto_card {\r\n               width: 35%;\r\n               max-width: 400px;\r\n\r\n               @media (max-width: 920px) {\r\n                  margin: 0 auto;\r\n                  width: 100%;\r\n                  max-width: 350px;\r\n               }\r\n            }\r\n         }\r\n      }\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"people": `People_people__N4JdE`,
	"cards": `People_cards__1WiNZ`,
	"card": `People_card__fqQ6P`,
	"inst": `People_inst__1mC3N`,
	"box_foto": `People_box_foto__3ZJ6d`,
	"foto": `People_foto__ESwpx`,
	"btn": `People_btn__6q7ld`,
	"bg_popup": `People_bg_popup__GAogA`,
	"box_popup": `People_box_popup__1OG8R`,
	"title": `People_title__LO0Wo`,
	"text_inst": `People_text_inst__G7VlV`,
	"close": `People_close__tkx1z`,
	"col": `People_col__kloOk`,
	"foto_card": `People_foto_card__wrC6J`
};
export default ___CSS_LOADER_EXPORT___;
